import { getResourceTo } from 'react/utils/utils';

class ServiceTimeUpdatesRouter extends App.Routers.GenericForm {
    TIMEOUTLARGEREQUESTS = 10800000;
    TIMEOUTMEDIUMREQUESTS = 15000;

    constructor() {
        super('ServiceTimeUpdates', 'ServiceTimeUpdates');

        const options = Monet.Grid.Utils.paginationOptions;

        App.Forms.ServiceTimeUpdates = App.Forms.ServiceTimeUpdates || {
            layout: {},
            pagination: {
                first: options.FIRST,
                max: options.MAX_RESULT,
                blocked: false,
                canIncrement: true
            },
            columnToOrders: undefined
        };

        Monet.Session.ServiceTimeUpdates = Monet.Session.ServiceTimeUpdates || { session: {} };
        App.Objects.ServiceTimeUpdates = this;
    }

    beforeCreateForm = (stage) => {
        var error = null;
        try {
            if (stage === "grid") {
                let html = "<div id='table_view_container'>";

                html += Greenmile.Templates.templateGridListTemplate({
                    title: getResourceTo('Monet.ServiceTimeUpdates.Tab.Title'),
                });

                html += "</div>";

                $("#ServiceTimeUpdates #form_and_grid").append(html);
            }
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on ater create form!");
            error.console();
        }
    }

    populateForm = (list) => {

        var value, field,
            model = list.first(),
            fields = App.Forms.ServiceTimeUpdates.form.fields,
            keyMapping = {
                "organizations": "organization",
                "accountTypes": "accountType",
                "locations": "location",
                "byServiceTimeType": "groupby"
            };

        if (model) {

            for (let key in model.attributes) {

                value = model.attributes[key];
                key = keyMapping[key] || key;
                field = fields[key];

                if (field) {
                   if (key === "groupby" && model.attributes.byServiceTimeType) {
                        field.setSelected('serviceTimeType');
                    } else {
                        field.setValue(value);
                    }
                }
            }
        }
    }

    loadLastByUser = () => {
        var ServiceTimeUpdSessions = new App.Collections.ServiceTimeUpdSessions();
        var criteria = '{"filters":["id", "*", "locations.id", "locations.description", "accountTypes.id", "accountTypes.description", "organizations.id", "organizations.description", "serviceTimeTypes.id", "serviceTimeTypes.description", "drivers.id", "drivers.name"],"orders":[], "firstResult":0,"maxResults":1}';

        ServiceTimeUpdSessions.filterWithRestrictions({
            criteria: criteria,
            filter: {
                "criteriaChain": [{ "and": [{ "attr": "user.id", "eq": Monet.Session.User.id }] }],
                "sort": [{ "attr": "id", "type": "DESC" }]
            },
            success: this.populateForm
        });
    }

    afterCreateForm = (stage) => {
        let error = null;
        try {
            if (stage === "form") {
                const view = new Greenmile.ServiceTimeUpdates.FormSearch();
                const title = Monet.I18n.getResourcesByKey("Greenmile.TimePicker.ServiceTimeUpdates.Title");

                view.addEventListener();

                $("#ServiceTimeUpdates #form_ServiceTimeUpdates .timePicker").timepicker("destroy");
                $("#ServiceTimeUpdates #form_ServiceTimeUpdates .timePicker").timepicker({
                    hourGrid: 4,
                    minuteGrid: 10,
                    secondGrid: 10,
                    showSecond: true,
                    timeFormat: new Monet.Date.GeneralFunctions().getTimeFormatWithSeconds(),
                    timeOnlyTitle: title,
                    beforeShow: () => {
                        $('main').append($('#ui-datepicker-div'));
                    }
                });

                $("#ServiceTimeUpdates #form_ServiceTimeUpdates .timePicker").on("click", function () {
                    $('.ui-datepicker-current').css('display', 'none');
                });

                $("#ServiceTimeUpdates #form_ServiceTimeUpdates .stepper-wrap .stepper-btn-wrap").remove();

                $("#ServiceTimeUpdates #form_ServiceTimeUpdates .numberPicker").stepper({
                    limit: [1, 1000]
                });

                this.loadLastByUser();
            }
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on after create form!", e);
            error.console();
        }
    }

    list = () => {
        App.Views.ServiceTimeUpdates.clearGridContainerAndShowAgain();
    }

    controlShowScreen = async () => {
        try {
            const sessionExists = await App.Objects.ServiceTimeUpdates.checkSessionExists();
            if (sessionExists.exists) {
                Monet.Session.ServiceTimeUpdates.session = sessionExists.sessionInfo;
                App.Views.ServiceTimeUpdates.showPopupInfoSessionExists();
            } else {
                App.Views.ServiceTimeUpdates.showFormSearchResult();
            }
        } catch (e) {
            const error = new Monet.Exception.ReturnError(this, "Error on control screen", e);
            error.console();
        }
    }

    checkSessionExists = async () => {
        var error = null,
            url = 'ServiceTimeUpdSession/CheckPending',
            result = { exists: false, sessionInfo: {} };

        try {
            const ajax = new Monet.Ajax();
            ajax.url = url;
            ajax.method = "get";
            ajax.timeout = this.TIMEOUTMEDIUMREQUESTS;

            ajax.success = function (data) {
                if (data) {
                    result.exists = true;
                    result.sessionInfo = data;
                }
            };

            await ajax.send();
            return result;
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on control screen");
            error.console();
        }
    }

    getFormLayout = () => {
        var action = "init";
        this.getProgressUpdate(null, this.controlShowScreen, action);
    }

    getDataUserInterfaceAndGenerateForm = (userInterfaceAction, callbackGenerateForm, stage, entityToLayout) => {
        var error = null,
            url = 'form/ServiceTimeUpdates/' + userInterfaceAction,
            that = this;

        if (entityToLayout) {
            url = 'form/' + entityToLayout + '/' + userInterfaceAction;
        }

        try {
            const ajax = new Monet.Ajax();
            ajax.url = url;
            ajax.method = "get";
            ajax.timeout = this.TIMEOUTMEDIUMREQUESTS;

            ajax.success = function (data) {
                App.Forms.ServiceTimeUpdates.layout = App.Forms.ServiceTimeUpdates.layout || {};

                if (userInterfaceAction === "index") {
                    App.Forms.ServiceTimeUpdates.layout.index = data;
                    var dm = new Monet.Builder.DataMapper();
                    dm.setEntity(entityToLayout);
                    dm.build(function () {
                        dm.copyDataMapperToAnotherNamespace('ServiceTimeUpdates');
                        that.generateForm(callbackGenerateForm, stage);
                    }, data);
                } else {
                    App.Forms.ServiceTimeUpdates.layout.form = data;
                    that.generateForm(callbackGenerateForm, stage);
                }
            };

            ajax.send();
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on get data user interface", e);
            error.console();
        }
    }

    generateForm = (callbackGenerateForm, stage) => {
        var error = null;

        try {
            if (this.beforeCreateForm) {
                this.beforeCreateForm(stage);
            }

            if (callbackGenerateForm) {
                callbackGenerateForm();
            }

            if (this.afterCreateForm) {
                this.afterCreateForm(stage);
            }
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on generate form.", e);
            error.console();
        }
    }

    getPendingSession = (notValidateEndSession) => {
        var error = null,
            validateEndSession = true;

        try {
            if (typeof notValidateEndSession !== "undefined" && notValidateEndSession === true) {
                validateEndSession = false;
            }

            this.getFilterAndUpdateGrid(validateEndSession);
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on get pending session.", e);
            error.console();
        }
    }

    getFilterAndUpdateGrid = (validateEndSession) => {
        App.Forms.ServiceTimeUpdates.pagination.first = 0;
        Monet.Session.ServiceTimeUpdates.allChecked = null;

        const filter = this.getFilter();

        const callback = (entity, tableLayout, data, addPagination, options) => {
            App.Forms.ServiceTimeUpdates.table.clearSelectedRows();
            Monet.Grid.addDataToGrid(entity, tableLayout, data, addPagination, options);
        }

        App.Forms.ServiceTimeUpdates.grid.updateGrid(filter, callback, undefined, validateEndSession);
    }


    updateGrid = (filter, callback, appendCollection, validateEndSession) => {
        App.Forms.ServiceTimeUpdates.grid.updateGrid(filter, callback, appendCollection, validateEndSession);
    }

    getFilter = () => {
        var error = null,
            byServiceTimeType = Monet.Session.ServiceTimeUpdates.session.byServiceTimeType,
            session = null,
            sessionId = null,
            columnToOrders = [],
            filter = {
                criteriaChain: []
            },
            unformatedColumnToOrder = null,
            fieldName = (byServiceTimeType ? "serviceTimeType" : "location"),
            defaultOrder = [
                { field: fieldName + '.key', order: "ASC" }
            ];

        try {
            session = Monet.Session.ServiceTimeUpdates.session;
            sessionId = session.id;
            unformatedColumnToOrder = App.Forms.ServiceTimeUpdates.columnToOrders;

            filter = App.Forms.ServiceTimeUpdates.filterBuilder.getCriteriaChain();
            filter.criteriaChain[0].and.push({ attr: "session.id", "eq": sessionId });
            filter.criteriaChain[0].and.push({ attr: "accepted", "isNull": true });

            if (!unformatedColumnToOrder) {
                columnToOrders = Monet.Grid.Utils.formatOrdersToRestriction(defaultOrder);
                App.Views.ServiceTimeUpdates.setGridOrderDefault(fieldName + '.key');
            } else {
                columnToOrders = Monet.Grid.Utils.formatOrdersToRestriction(unformatedColumnToOrder);
            }

            if (columnToOrders.length > 0) {
                filter.sort = columnToOrders;
            }

            return filter;
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on get filter", e);
            error.console();
        }
    }

    endSession = (messageKey, openModal) => {
        var error = null,
            url = 'ServiceTimeUpdSession/End',
            ajax = null,
            modal = null,
            view = null;

        try {
            modal = this.getModalInstance();

            if (openModal) {
                modal.showModalForm();
            }

            ajax = new Monet.Ajax();
            ajax.url = url;
            ajax.method = "post";
            ajax.timeout = this.TIMEOUTLARGEREQUESTS;

            ajax.success = function (result) {
                modal.closeModalWindow();

                const onAfterCloseModalForm = () => {
                    App.Views.ServiceTimeUpdates.clearGrid();
                    App.Views.ServiceTimeUpdates.showFormSearchResult();
                };

                if (result === true) {
                    if (openModal) {
                        view = App.Views.ServiceTimeUpdates;
                        view.showSessionClosedOnSuccess(messageKey, onAfterCloseModalForm);
                    } else {
                        onAfterCloseModalForm();
                    }
                }
            };

            ajax.error = function (xhr) {
                Monet.Configurations.errorNotification(null, xhr, null, null);
                modal.closeModalWindow();
            };

            ajax.send();

        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on get data user interface");
            error.console();
        }
    }

    generateSession = (data, showErrors) => {
        var error = null,
            url = 'ServiceTimeUpdSession/CreateSession',
            ajax = null;

        try {
            if (data) {
                ajax = new Monet.Ajax();
                ajax.url = url;
                ajax.method = "post";
                ajax.data = data;
                ajax.success = function (content) {
                    if (content && content.id > 0) {
                        delete App.Forms.ServiceTimeUpdates.columnToOrders;
                        App.Views.ServiceTimeUpdates.destroyFormAndShowProgressAlert();
                        Monet.Session.ServiceTimeUpdates.session = content;
                    }
                };
                ajax.error = (response) => {
                    showErrors(JSON.parse(response.responseText));
                };
            }
            ajax.send();
        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on generate session.");
            error.console();
        }
    }

    getProgressUpdate = (updateCallback, completeCallback, action) => {
        try {
            const ajax = new Monet.Ajax();
            ajax.url = "ServiceTimeUpdSession/CheckSessionStatusProgress";
            ajax.method = "get";
            ajax.success = function (content) {
                if (content) {
                    const progress = new Greenmile.ServiceTimeUpdates.ProgressSessionAlert("#ServiceTimeUpdates");

                    if (action === "init") {
                        App.Views.ServiceTimeUpdates.showProgressAlert(content.progress);
                    } else {
                        progress.update(content.progress);
                    }

                    if (updateCallback) {
                        updateCallback();
                    }
                } else if (completeCallback) {
                    completeCallback();
                }
            };

            ajax.send();
        } catch (e) {
            const error = new Monet.Exception.ReturnError(this, "Error on get progress update.");
            error.console();
        }
    }


    updateServiceTimeUpdate = (data, id) => {
        var error = null,
            url = "",
            ajax = null;

        try {
            if (data) {
                url = App.Forms.ServiceTimeUpdates.grid.entityToRequest + '/' + id + "/Update";

                ajax = new Monet.Ajax();
                ajax.url = url;
                ajax.method = "post";
                ajax.data = data;

                ajax.send();
            }
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on update service time update location.");
            error.console();

        }
    }

    formatDataToSend = (dataItem, setId) => {
        const data = {},
            model = dataItem.model.attributes,
            item = dataItem;

        data.userFixTimeSecs = item.sugFixTimeSecs || model.sugFixTimeSecs;
        data.userVarTimeSecs = item.sugVarTimeSecs || model.sugVarTimeSecs;

        if (setId) {
            data.id = dataItem.idOfObject;
        }

        return data;
    }

    getDataToAccept = (row) => {
        var error = null,
            grid = null,
            dataItem = null;

        try {
            grid = App.Forms.ServiceTimeUpdates.table;
            dataItem = grid.getDataItem(row);
            return this.formatDataToSend(dataItem);
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on get data to accept.");
            error.console();
        }
    }

    getDataToAcceptSelected = (rows) => {
        var error = null,
            grid = null,
            dataItem = null,
            arrayData = [],
            setId = true;

        try {
            grid = App.Forms.ServiceTimeUpdates.table;

            for (var i = 0; i < rows.length; i++) {
                var row = rows[i];
                dataItem = grid.getDataItem(row);
                arrayData.push(this.formatDataToSend(dataItem, setId));
            }

            return arrayData;
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on get data to accept.");
            error.console();
        }
    }

    getDataToRejectSelected = (rows) => {
        var error = null,
            grid = null,
            dataItem = null,
            arrayData = [];

        try {
            grid = App.Forms.ServiceTimeUpdates.table;

            for (var i = 0; i < rows.length; i++) {
                var row = rows[i];
                dataItem = grid.getDataItem(row);
                arrayData.push({ "id": dataItem.idOfObject });
            }

            return arrayData;
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on get data to accept.");
            error.console();
        }
    }

    afterSuccessAceptOrReject = () => {
        App.Objects.ServiceTimeUpdates.getFilterAndUpdateGrid(true);
    }

    acceptAndRemoveRow = (id, row) => {

        var error = null,
            url = "",
            ajax = null,
            data = null,
            that = this;

        try {

            if (id) {

                url = App.Forms.ServiceTimeUpdates.grid.entityToRequest + '/' + id + "/Accept";
                data = this.getDataToAccept(row[0]);

                ajax = new Monet.Ajax();
                ajax.url = url;
                ajax.timeout = this.TIMEOUTMEDIUMREQUESTS;
                ajax.method = "post";
                ajax.data = data;

                ajax.success = function (result) {
                    if (result === true) {
                        that.afterSuccessAceptOrReject(row);
                    }

                    $('#loading_img').hide();
                };

                ajax.error = function (xhr) {
                    Monet.Configurations.errorNotification(null, xhr, null, null);
                    $('#loading_img').hide();
                };

                $('#loading_img').show();

                ajax.send();

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on accept service time update location.");
            error.console();

        }
    }

    rejectAndRemoveRow = (id, row) => {

        var error = null,
            ajax = null,
            that = this;

        try {

            if (id) {

                ajax = new Monet.Ajax();
                ajax.url = App.Forms.ServiceTimeUpdates.grid.entityToRequest + '/' + id + "/Reject";
                ajax.timeout = this.TIMEOUTMEDIUMREQUESTS;

                ajax.success = function (result) {
                    if (result === true) {
                        that.afterSuccessAceptOrReject(row);
                    }

                    $('#loading_img').hide();
                };

                ajax.error = function (xhr) {
                    Monet.Configurations.errorNotification(null, xhr, null, null);
                    $('#loading_img').hide();
                };

                $('#loading_img').show();

                ajax.send();

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on reject service time update location.");
            error.console();

        }
    }

    acceptSelected = (rows, params) => {
        this.toggleLoadingInBtn();

        params = params || App.Forms.ServiceTimeUpdates.grid.getParams();
        var error = null,
            ajax = null,
            data = params.data,
            url = params.url + '/AcceptSelected',
            that = this;

        try {

            data[params.objName] = this.getDataToAcceptSelected(rows);

            ajax = new Monet.Ajax();
            ajax.url = url;
            ajax.method = "post";
            ajax.timeout = this.TIMEOUTLARGEREQUESTS;
            ajax.data = data;

            ajax.success = function (result) {
                if (result === true) {
                    that.afterSuccessAceptOrReject(rows);
                }
                that.toggleLoadingInBtn();
            };

            ajax.error = function (xhr) {

                Monet.Configurations.errorNotification(null, xhr, null, null);
                that.toggleLoadingInBtn();

            };

            ajax.send();

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on send data to accept selected.");
            error.console();
        }
    }

    rejectSelected = (rows, params) => {
        this.toggleLoadingInBtn();

        params = params || App.Forms.ServiceTimeUpdates.grid.getParams();
        var error = null,
            ajax = null,
            data = params.data,
            url = params.url + '/RejectSelected',
            that = this;

        try {

            data[params.objName] = this.getDataToRejectSelected(rows);

            ajax = new Monet.Ajax();
            ajax.url = url;
            ajax.method = "post";
            ajax.timeout = this.TIMEOUTLARGEREQUESTS;
            ajax.data = data;

            ajax.success = function (result) {
                if (result === true) {
                    that.afterSuccessAceptOrReject(rows);
                }
                that.toggleLoadingInBtn();
            };

            ajax.error = function (xhr) {

                that.toggleLoadingInBtn();
                Monet.Configurations.errorNotification(null, xhr, null, null);

            };

            ajax.send();

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on send data to accept selected.");
            error.console();
        }
    }

    acceptAll = () => {
        this.toggleLoadingInBtn();

        var error = null,
            ajax = null,
            url = "",
            id = 0,
            that = this;

        try {

            id = Monet.Session.ServiceTimeUpdates.session.id;

            url = "ServiceTimeUpdSession/" + id + "/AcceptAll";

            ajax = new Monet.Ajax();
            ajax.url = url;
            ajax.timeout = this.TIMEOUTLARGEREQUESTS;

            ajax.success = function (result) {
                if (result === true) {
                    that.endSession("Greenmile.ServiceTimeUpdates.sessionIsFinished");
                }
                that.toggleLoadingInBtn();
            };

            ajax.error = function (xhr) {
                that.toggleLoadingInBtn();
                Monet.Configurations.errorNotification(null, xhr, null, null);
            };

            ajax.send();

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on send accept all");
            error.console();

        }
    }

    rejectAll = () => {
        this.toggleLoadingInBtn();

        var error = null,
            ajax = null,
            url = "",
            id = 0,
            that = this;

        try {
            id = Monet.Session.ServiceTimeUpdates.session.id;

            url = "ServiceTimeUpdSession/" + id + "/RejectAll";

            ajax = new Monet.Ajax();
            ajax.url = url;
            ajax.timeout = this.TIMEOUTLARGEREQUESTS;

            ajax.success = function (result) {
                if (result === true) {
                    that.endSession("Greenmile.ServiceTimeUpdates.sessionIsFinished");
                }
                that.toggleLoadingInBtn();
            };

            ajax.error = function (xhr) {
                that.toggleLoadingInBtn();
                Monet.Configurations.errorNotification(null, xhr, null, null);
            };

            ajax.send();

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on send accept all");
            error.console();
        }
    }

    verifyPendingLocationsToUpdate = () => {

        var error = null,
            ajax = null,
            url = App.Forms.ServiceTimeUpdates.grid.entityToRequest + "/aggregate",
            sessionId = 0,
            filter = {
                aggregate: [
                    {
                        "function": "COUNT",
                        "attr": ["id"]
                    }
                ],
                criteriaChain: [
                    {
                        "and": [
                            {
                                "attr": "session.id",
                                "eq": null
                            },
                            {
                                "attr": "accepted",
                                "isNull": true
                            }
                        ]
                    }
                ]
            },
            that = this,
            openModal = true;

        try {

            sessionId = Monet.Session.ServiceTimeUpdates.session.id;
            filter.criteriaChain[0].and[0].eq = sessionId;

            ajax = new Monet.Ajax();
            ajax.url = url;
            ajax.method = "post";
            ajax.data = filter;

            ajax.success = function (result) {
                if (result) {
                    if (result.count.total > 0) {
                        App.Views.ServiceTimeUpdates.clearAllFiltersAndUpdateGrid();
                    } else {
                        that.endSession("Greenmile.ServiceTimeUpdates.sessionIsFinished", openModal);
                    }
                }
            };

            ajax.send();

        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on verify pending locations to update.");
            error.console();
        }
    }

    getModalInstance = () => {

        var selector = "#ServiceTimeUpdates";
        var scopeBlock = "#ServiceTimeUpdates #form_and_grid";

        var options = {
            width: 400,
            height: 250
        };

        var callbacks = {
            onAfterShowModalForm: () => {
                var popupFormContainer = $("#ServiceTimeUpdates .popupFormContainer");
                var closeModalWindow = $("#ServiceTimeUpdates .closeModalWindow");
                const image = require("static/images/general/loading_blue.svg");
                var img = '<div class="loading"><img src="' + image + '"></div>';

                popupFormContainer.hide();
                closeModalWindow.hide();

                $(".blockUI.blockOverlay").html(img);
            }
        };

        var modal = new Monet.Form.Modal(selector, options, callbacks, scopeBlock);
        return modal;

    }

    toggleLoadingInBtn = function() {
  
        const formButtonsContent = document.querySelector("#ServiceTimeUpdates .buttonsContainer");
        if(formButtonsContent) {
            var divsContainersOfButtons = Array.from(formButtonsContent.childNodes);

            for (var div of divsContainersOfButtons) {
                const btn = div.querySelector("input");
                btn.classList && btn.classList.toggle("loader-spinner");
                btn.disabled = !btn.disabled;
            }
        }
    }
}

App.Routers.ServiceTimeUpdates = ServiceTimeUpdatesRouter;
